<template>
  <div>
    <b-modal
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      id="modalEditarMensagemModelo"
      title="Criar Modelo Mensagem"
    >
      <!-- Modal Header -->
      <template #modal-header>
        <h5 class="modal-title">Modelo Mensagem</h5>
        <div class="modal-actions">
          <feather-icon
            icon="MinusIcon"
            class="cursor-pointer"
            @click="$bvModal.hide('modalEnviarMensagem')"
          />
          <feather-icon
            icon="XIcon"
            class="ml-1 cursor-pointer"
            @click="fecharModal"
          />
        </div>
      </template>
      
      <b-alert :variant="getErrors.color" v-if="getErrors.hasMessage" show="">
        <div class="alert-body text-bold">{{ getErrors.message }}</div>
        <div
          class="alert-body"
          v-for="(error, index) in getErrors.messageArray"
          :key="index"
        >
          {{ error[0] }}
        </div>
      </b-alert>
      
      <validation-observer ref="createModeloMensagensValidation">
        <b-form>
          
          <b-row>
            <!-- IDIOMA -->
            <b-col cols="12" lg="4" md="4">
              <b-form-group label="Idioma" label-for="idioma">
                <b-form-select
                  id="idioma"
                  v-model="form.idioma"
                  :options="idiomas"
                />
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row class="mb-2">
            <b-col>
              <b-form-checkbox
                switch
                id="checkbox-ativo"
                v-model="form.ativo"
                class="custom-control-primary"
              >
                Ativar Envio da Mensagem
              </b-form-checkbox>
            </b-col>
          </b-row>
          
          <b-row>
            <!-- NOME-->
            <b-col cols="12" lg="6" md="6">
              <b-form-group label="Nome do Modelo (Identificação Interna)" label-for="nome_editar">
                <validation-provider
                  #default="{ errors }"
                  name="nome"
                  rules="required|max:100"
                >
                  <b-form-input
                    id="nome_editar"
                    v-model="form.nome"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            
            <!-- TITULO-->
            <b-col cols="12" lg="6" md="6">
              <b-form-group label="Titulo da Mensagem (Assunto)" label-for="titulo_editar">
                <validation-provider
                  #default="{ errors }"
                  name="Título"
                  rules="required|max:255"
                >
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    id="titulo_editar"
                    v-model="form.titulo"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          
          </b-row>
          
          <b-row>
            
            <!-- PLANOS-->
            <b-col cols="12" lg="4" md="4">
              <b-form-group label="Plano" label-for="plano_editar">
                <b-form-select
                  id="plano_editar"
                  v-model="form.plano"
                  :options="planos"
                />
              </b-form-group>
            </b-col>
            
            <!-- GATILHOS-->
            <b-col cols="12" lg="5" md="5">
              <b-form-group label="Tipo Gatilhos" label-for="tipo_gatilhos_editar">
                <b-form-select
                  id="tipo_gatilhos_editar"
                  v-model="form.tipo_gatilho"
                  :options="gatilhos"
                  @change="alterouGatilho"
                />
              </b-form-group>
            </b-col>
            
            <!-- DIAS OFFSET-->
            <b-col cols="12" lg="3" md="3">
              <b-form-group label="Dias Offset" label-for="dias_offset_editar">
                <b-form-spinbutton
                  id="sb-dias_offset_editar"
                  v-model="form.dias_offset"
                  :min="form.tipo_gatilho === 'data_expiracao' ? -360 : 0 "
                  max="360"
                />
              </b-form-group>
            </b-col>
          
          </b-row>
          
          <b-row class="mt-3 mb-3">
            <b-col>
              <validation-provider
                #default="{ errors }"
                name="conteúdo"
                rules="required"
              >
                <quill-editor
                  v-model="form.conteudo"
                  :options="snowOption"
                  id="quill-editor-conteudo"
                
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            
            
          </b-row>
          
          
          <!-- LINK-->
          
          <b-row>
            <b-col cols="5">
              <b-form-group label="Título do Botão" label-for="titulo_botao_editar">
                <validation-provider
                  #default="{ errors }"
                  name="Título Botão"
                  rules="required|max:100"
                >
                  <b-form-input
                    id="titulo_botao_editar"
                    class="mt-1"
                    v-model="form.titulo_botao"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Ex.: Clique aqui para acessar o Conteúdo"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="7" >
              <b-form-group label="Link Botão (mensagem via sistema direciona o usuário)" label-for="link_editar">
                <b-form-input
                  id="link_editar"
                  class="mt-1"
                  v-model="form.link"
                  placeholder="Link"
                />
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col>
              <div class="demo-inline-spacing">
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="form.sistema"
                  class="custom-control-primary"
                >
                  Sistema
                </b-form-checkbox>
                
                <b-form-checkbox
                  id="checkbox-2"
                  v-model="form.whatsapp"
                  class="custom-control-primary"
                >
                  Whatsapp
                </b-form-checkbox>
                
                <b-form-checkbox
                  id="checkbox-3"
                  v-model="form.email"
                  class="custom-control-primary"
                >
                  Email
                </b-form-checkbox>
              
              </div>
            </b-col>
          </b-row>
        
        
        </b-form>
      </validation-observer>
      <hr />
      <b-row align-h="between" class="px-1">
        <b-button @click="fecharModal">Cancelar</b-button>
        <b-button @click="gravarModelo" variant="primary"
        ><b-spinner small v-if="spinner" />
          <span v-if="spinner">Aguarde...</span>
          <span v-else>Gravar Modelo</span></b-button
        >
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BAlert,
  BAvatar,
  BButton,
  BCol,
  BDropdown,
  BDropdownDivider,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormSelect, BFormSpinbutton,
  BFormTextarea,
  BRow,
  BSpinner,
  VBToggle,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {mapState} from "vuex";
import {ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@core/utils/validations/validations";
import planos from "@/views/mensagens/modelos/planos";
import QuillEditor from "vue-quill-editor/src/editor.vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  directives: { "b-toggle": VBToggle, Ripple },
  props: ['form'],
  mixins: [planos],
  components: {
    QuillEditor,
    BFormSpinbutton,
    required,
    BFormSelect,
    BFormCheckbox,
    BDropdown,
    BDropdownItem,
    BForm,
    BFormInput,
    BAvatar,
    BDropdownDivider,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormTextarea,
    BAlert,
    BSpinner,
    ValidationObserver,
    ValidationProvider,
    ToastificationContent,
  },
  
  data() {
    return {
      disableDiasoffset: false,
      snowOption: {
        placeholder: "Escreva a sua Mensagem aqui...",
        theme: "snow",
      },
      idiomas: [
        { value: 'pt-br', text: 'Português' },
        { value: 'en', text: 'Inglês' },
        { value: 'es', text: 'Espanhol' }
      ],
      gatilhos: [
        { value: 'data_inicio', text: 'Data Início da assinatura', aceitaNegativo: false},
        { value: 'data_expiracao', text: 'Data Expiração', aceitaNegativo: true},
        { value: 'data_cancelamento', text: 'Data cancelamento', aceitaNegativo: false},
        { value: 'data_upgrade', text: 'Data Upgrade', aceitaNegativo: false}
      ],
      spinner: false,
      submit: false,
      getErrors: {
        hasMessage: false,
        color: "danger",
        message: "",
        messageArray: "",
      },
      errorEmails: [],
    };
  },
  
  computed: {
    ...mapState({
      filtros: (state) => state.mensagens,
    }),
  },
  
  methods: {
    gravarModelo() {
      
      this.$refs.createModeloMensagensValidation.validate().then((valid) => {
        
        if(valid) {
          this.spinner = true
          this.submit = true
          
          this.$http
            .put(`adm/mensagens/${this.form.id}`, this.form)
            .then((res) => {
              if (res.data) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Modelo de Mensagem Cadastrdao com Sucesso!",
                    icon: "InfoIcon",
                    variant: "success",
                  },
                });
                
                this.resetaErros();
                this.fecharModal();
                
                this.$store.dispatch('modeloMensagens/listaModelos')
              }
            })
            .catch((error) => {
              this.getErrors = this.$responseMessages.getMessage(error, null);
            })
            .finally(() => {
              this.spinner = false;
              this.submit = false;
            });
        }
      })
      
    },
    alterouGatilho(value) {
      this.form.dias_offset = 1
    },
    
    fecharModal() {
      this.resetaErros();
      this.$bvModal.hide("modalEditarMensagemModelo");
    },
    
    resetaErros() {
      this.getErrors = {
        hasMessage: false,
        color: "danger",
        message: "",
        messageArray: "",
      };
    },
    
  },
};
</script>

<style lang="scss" scoped>

.ql-editor {
  min-height: 200px; /* Ajuste este valor para a altura mínima desejada */
}

.borderless-input {
  border: none;
  border-radius: 0;
  background-color: transparent; /* Define o fundo como transparente */
  box-shadow: none; /* Remove a sombra */
}

.borderless-input:focus {
  background-color: transparent; /* Mantém o fundo transparente quando o input está em foco */
  box-shadow: none; /* Remove a sombra quando o input está em foco */
}
</style>

<style lang="scss" scoped>
::v-deep .ql-editor {
  min-height: 200px;
}
</style>
